import React from 'react'
import { DataTable, TextInput, Button } from '@paypalcorp/pp-react'
import Fuse from 'fuse.js'

// This is an optional object to be used in the SearchableTableACDCNotCollapsed object to format content.
// CodeCurrencyFormat takes 2 strings and returns the values as formatted HTML.
// The expected input for value is a 3-letter currency code value.
// The expected input for footnote is 1 alphanumeric character. This value is optional.
// CodeCurrencyFormat formats the currency code passed by value as code.
// CodeCurrencyFormat formats the optional footnote passed by footnote as superscript
// as well as a link to the corresponding footnote in the legend section
// Note: CodeCurrencyFormat doesn't sanitize the input, so the values could be anything.
// Note: CodeCurrencyFormat doesn't check whether a footnote value was passed.
// If there was no footnote passed, CodeCurrencyFormat returns the superscript formatting around a blank value.

const CodeCurrencyFormat = (value, footnote) => {
  return (
    <div>
      <code>{value.value}</code>
      <sup>
        <a href={'#link-footnote-' + value.footnote}>{value.footnote}</a>
      </sup>
    </div>
  )
}

export default CodeCurrencyFormat
